import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { AxiosApi } from "../../helpers/AxiosApi";
import initialStates from "./state";

// Get Service Requests
export const getServiceRequests = createAsyncThunk(
  "getServiceRequests",
  async ({ search, priority, period, status }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(
        `service-requests?search=${search}&priority=${priority}&period=${period}&status=${status}`
      );
      return response.data.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Create Services Request
export const createServicesRequest = createAsyncThunk(
  "createServicesRequest",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`service-requests`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Get Service Requests By company Id
export const getServiceRequestsByCompany = createAsyncThunk(
  "getServiceRequestsByCompany",
  async (company_id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(
        `service-requests?company_id=${company_id}`
      );
      return response.data.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Get Service Requests users
export const getServiceRequestsUsers = createAsyncThunk(
  "getServiceRequestsUsers",
  async (companyId, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(
        `service-requests-users?type=shareholder,director&company_id=${companyId}`
      );
      return response.data.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Update Service
export const updateService = createAsyncThunk(
  "updateService",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.put(`service-requests/${id}`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Create Quick Action
export const CreateQuickAction = createAsyncThunk(
  "CreateQuickAction",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`chat-quick-action`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Delete Service Request
export const deleteServiceRequest = createAsyncThunk(
  "deleteServiceRequest",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(`service-requests/${id}`);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Get service requests users List
export const serviceRequestsUsers = createAsyncThunk(
  "serviceRequestsUsers",
  async ({ type, company_id }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(
        `service-requests-users?type=${type}&company_id=${company_id}`
      );
      return response.data.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

const serviceRequestSlice = createSlice({
  name: "serviceRequest",
  initialState: initialStates,
  extraReducers: (builder) => {
    builder
      // get Service Requests
      .addCase(getServiceRequests.pending, (state) => {
        state.loading = true;
      })
      .addCase(getServiceRequests.fulfilled, (state, action) => {
        state.loading = false;
        state.getServiceRequestsStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getServiceRequests.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Create Services Request
      .addCase(createServicesRequest.pending, (state) => {
        state.loading = true;
      })
      .addCase(createServicesRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.createServicesRequestStatus.data = action.payload;
        state.error = false;
      })
      .addCase(createServicesRequest.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Update Service
      .addCase(updateService.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateService.fulfilled, (state, action) => {
        state.loading = false;
        state.updateServiceStatus.data = action.payload;
        state.error = false;
      })
      .addCase(updateService.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Get service requests users List
      .addCase(serviceRequestsUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(serviceRequestsUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.serviceRequestsUsersStatus.data = action.payload;
        state.error = false;
      })
      .addCase(serviceRequestsUsers.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // get Service Requests Users
      .addCase(getServiceRequestsUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getServiceRequestsUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.getServiceRequestsUsersStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getServiceRequestsUsers.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // delete Service Request
      .addCase(deleteServiceRequest.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteServiceRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.deleteServiceRequestStatus.data = action.payload;
        state.error = false;
      })
      .addCase(deleteServiceRequest.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Create Quick Action
      .addCase(CreateQuickAction.pending, (state) => {
        state.loading = true;
      })
      .addCase(CreateQuickAction.fulfilled, (state, action) => {
        state.loading = false;
        state.CreateQuickActionStatus.data = action.payload;
        state.error = false;
      })
      .addCase(CreateQuickAction.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // get Service Requests By Company
      .addCase(getServiceRequestsByCompany.pending, (state) => {
        state.loading = true;
      })
      .addCase(getServiceRequestsByCompany.fulfilled, (state, action) => {
        state.loading = false;
        state.getServiceRequestsByCompanyStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getServiceRequestsByCompany.rejected, (state) => {
        state.loading = false;
        state.error = true;
      });
  },
});
const { reducer } = serviceRequestSlice;
export default reducer;
